var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Getter } from '@devexpress/dx-react-core';
import { GroupingState, IntegratedGrouping, IntegratedSelection, IntegratedSorting, RowDetailState, SelectionState, SortingState } from '@devexpress/dx-react-grid';
import { Grid, Table, TableGroupRow, TableHeaderRow, TableRowDetail, TableSelection, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { Checkbox } from '@material-ui/core';
import classNames from 'classnames';
import { xor } from 'lodash';
import * as React from 'react';
import { useCallback, useRef } from 'react';
import { neutralsGray, white } from '../../Styles/Colours';
import { Button, ButtonMode } from '../Button';
import { FloatingLinearProgress } from '../FloatingLinearProgress';
import { ArrowDownIcon, ArrowRightIcon, ArrowUpIcon } from '../Icons';
import styles from './ImprovedDataTable.module.css';
import { LoadMoreFooter } from './LoadMoreFooter';
/** Changes the scroll mode for the grid */
export var ScrollMode;
(function (ScrollMode) {
    /**
     * @description Virtual scrolling increases performance by rendering results in a known window size.
     * It is useful when there are many results as user is unable to view most of the data and therefore there is no benefit rendering it.
     */
    ScrollMode["virtual"] = "virtual";
    /**
     * @description Normal scrolling disables virtual scrolling which means all results will be rendered.
     * Using normal scrolling can be beneficial when you have only a few results where scrolling doesnt occur often
     * NOTE: Using normal scroll mode disables sticky headers.
     */
    ScrollMode["normal"] = "normal";
})(ScrollMode || (ScrollMode = {}));
function RootComponent(props) {
    return (React.createElement(Grid.Root, __assign({}, props, { style: {
            width: '100%',
            height: '100%'
        } })));
}
var VirtualTableComponent = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(VirtualTable.Table, __assign({}, props, { className: styles.virtualTable }));
};
function TableBody(props) {
    return React.createElement(Table.TableBody, __assign({}, props, { className: styles.body }));
}
function HeaderCell(props) {
    return React.createElement(TableHeaderRow.Cell, __assign({}, props, { className: styles.headerCell }));
}
function HeaderSelectionCellComponent(props) {
    var _a;
    return (React.createElement(TableSelection.HeaderCell, __assign({}, props, { className: classNames(styles.headerCellComponent, (_a = {},
            _a[styles.headerCellComponentSelected] = props.someSelected,
            _a)) })));
}
function HeaderRow(props) {
    return React.createElement(TableHeaderRow.Row, __assign({}, props, { className: styles.headerRow, style: { backgroundColor: props.colour } }));
}
function TableHeaderStub(props) {
    return React.createElement(Table.StubHeaderCell, __assign({}, props, { className: styles.headerStub }));
}
export var ImprovedDataTableButtonHider = function (props) {
    return React.createElement("div", { className: styles.buttonHider }, props.children);
};
export function ImprovedDataTable(props) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var containerRef = useRef(null);
    var sanitisedScrollMode = (_b = props.scrollMode) !== null && _b !== void 0 ? _b : ScrollMode.virtual;
    var expandedIds = ((_d = (_c = props.rowExpansion) === null || _c === void 0 ? void 0 : _c.expandedIds) !== null && _d !== void 0 ? _d : []).join('|');
    var selectedIds = ((_f = (_e = props.rowChecking) === null || _e === void 0 ? void 0 : _e.selectedIds) !== null && _f !== void 0 ? _f : []).join('|');
    function ToggleCell(toggleCellProps) {
        var _a;
        var _b, _c;
        var expanded = toggleCellProps.expanded, onToggle = toggleCellProps.onToggle, others = __rest(toggleCellProps, ["expanded", "onToggle"]);
        var onClick = function (event) {
            event.stopPropagation();
            event.preventDefault();
            onToggle();
        };
        var detailCellStyles = classNames(styles.detailCell, (_a = {},
            _a[styles.expanded] = toggleCellProps.expanded,
            _a[styles.expanderOnLeft] = (_b = props.rowExpansion) === null || _b === void 0 ? void 0 : _b.expanderOnLeft,
            _a));
        return (React.createElement(TableRowDetail.Cell, __assign({}, others, { className: detailCellStyles }),
            React.createElement(Button, { iconOnly: true, onClick: onClick, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'expand' }, !((_c = props.rowExpansion) === null || _c === void 0 ? void 0 : _c.expanderOnLeft) ? (toggleCellProps.expanded ? (React.createElement(ArrowUpIcon, { color: neutralsGray })) : (React.createElement(ArrowDownIcon, { color: neutralsGray }))) : toggleCellProps.expanded ? (React.createElement(ArrowDownIcon, { color: neutralsGray })) : (React.createElement(ArrowRightIcon, { color: neutralsGray })))));
    }
    var ContainerComponent = useCallback(function (containerComponentProps) {
        var _a;
        var containerClasses = classNames(styles.containerComponent, (_a = {},
            _a[styles.fillParentHeight] = props.fillParentHeight,
            _a[styles.noBorder] = props.noTableBorder,
            _a));
        return React.createElement(VirtualTable.Container, __assign({}, containerComponentProps, { className: containerClasses }));
    }, [props.noTableBorder]);
    var handleSelection = useCallback(function (selectedIds, selectAll) {
        var _a;
        if (selectAll === void 0) { selectAll = false; }
        if ((_a = props.rowChecking) === null || _a === void 0 ? void 0 : _a.onSelectedChanged) {
            props.rowChecking.onSelectedChanged(selectedIds, selectAll);
        }
    }, [props.data, selectedIds]);
    var handleRowExpansion = useCallback(function (expandedIds) {
        if (props.rowExpansion) {
            var changed_1 = xor(props.rowExpansion.expandedIds, expandedIds);
            if (changed_1.length > 0) {
                var row = props.data.find(function (it) { return props.getRowId(it) === changed_1[0]; });
                if (row)
                    props.rowExpansion.onExpand(row);
            }
        }
    }, [props.data, expandedIds]);
    var CustomToggleCell = React.useCallback(function (cellProps) {
        var _a, _b, _c, _d, _e;
        var onToggle = cellProps.onToggle, expanded = cellProps.expanded, others = __rest(cellProps, ["onToggle", "expanded"]);
        var selected = (_b = (_a = props.rowChecking) === null || _a === void 0 ? void 0 : _a.selectedIds.includes(props.getRowId(cellProps.row))) !== null && _b !== void 0 ? _b : false;
        var classes = classNames(styles.detailCell, (_c = props.cellStyles) === null || _c === void 0 ? void 0 : _c.call(props, { data: cellProps.row, selected: selected, expanded: expanded }));
        return (React.createElement(TableRowDetail.Cell, __assign({}, others, { key: "toggle-cell-" + props.getRowId(cellProps.row), className: classes }), ((_d = props.rowExpansion) === null || _d === void 0 ? void 0 : _d.toggleCell)
            ? (_e = props.rowExpansion) === null || _e === void 0 ? void 0 : _e.toggleCell({ data: cellProps.row, expanded: expanded, onToggle: onToggle })
            : null));
    }, [(_g = props.rowExpansion) === null || _g === void 0 ? void 0 : _g.toggleCell, selectedIds]);
    var RowComponentWithSelection = React.useCallback(function (rowProps) {
        var _a, _b, _c, _d, _e;
        var selectByRowClick = rowProps.selectByRowClick, highlighted = rowProps.highlighted, onToggle = rowProps.onToggle, otherProps = __rest(rowProps, ["selectByRowClick", "highlighted", "onToggle"]);
        var expanded = (_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.expandedIds.includes(props.getRowId(rowProps.tableRow.row))) !== null && _b !== void 0 ? _b : false;
        var classes = classNames(styles.row, (_c = props === null || props === void 0 ? void 0 : props.rowStyles) === null || _c === void 0 ? void 0 : _c.call(props, { data: rowProps.tableRow.row, selected: highlighted !== null && highlighted !== void 0 ? highlighted : false, expanded: expanded }), (_e = (_d = props.rowChecking) === null || _d === void 0 ? void 0 : _d.rowStyles) === null || _e === void 0 ? void 0 : _e.call(_d, { data: rowProps.tableRow.row, highlighted: highlighted !== null && highlighted !== void 0 ? highlighted : false }));
        return React.createElement(VirtualTable.Row, __assign({}, otherProps, { row: rowProps.tableRow.row, className: classes }));
    }, [(_h = props.rowChecking) === null || _h === void 0 ? void 0 : _h.rowStyles, expandedIds]);
    var DetailRowComponent = React.useCallback(function (rowProps) {
        var _a, _b;
        var classes = classNames((_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.rowStyles) === null || _b === void 0 ? void 0 : _b.call(_a, { data: rowProps.row }));
        return React.createElement(TableRowDetail.Row, __assign({}, rowProps, { className: classes }));
    }, []);
    var DetailCellComponent = React.useCallback(function (cellProps) {
        var _a, _b;
        var classes = classNames((_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.cellStyles) === null || _b === void 0 ? void 0 : _b.call(_a, { data: cellProps.row }));
        return React.createElement(TableRowDetail.Cell, __assign({}, cellProps, { className: classes }));
    }, []);
    var CellComponent = React.useCallback(function (cellProps) {
        var _a, _b, _c, _d, _e;
        var expanded = (_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.expandedIds.includes(props.getRowId(cellProps.row))) !== null && _b !== void 0 ? _b : false;
        var selected = (_d = (_c = props.rowChecking) === null || _c === void 0 ? void 0 : _c.selectedIds.includes(props.getRowId(cellProps.row))) !== null && _d !== void 0 ? _d : false;
        var classes = classNames(styles.cell, (_e = props.cellStyles) === null || _e === void 0 ? void 0 : _e.call(props, { data: cellProps.row, selected: selected, expanded: expanded }));
        return React.createElement(VirtualTable.Cell, __assign({}, cellProps, { className: classes }));
    }, [expandedIds, selectedIds]);
    var DefaultRowComponent = React.useCallback(function (cellProps) {
        var _a, _b, _c, _d, _e;
        var expanded = (_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.expandedIds.includes(props.getRowId(cellProps.row))) !== null && _b !== void 0 ? _b : false;
        var selected = (_d = (_c = props.rowChecking) === null || _c === void 0 ? void 0 : _c.selectedIds.includes(props.getRowId(cellProps.row))) !== null && _d !== void 0 ? _d : false;
        var classes = classNames(styles.defaultRow, (_e = props === null || props === void 0 ? void 0 : props.rowStyles) === null || _e === void 0 ? void 0 : _e.call(props, { data: cellProps.row, selected: selected, expanded: expanded }));
        return React.createElement(VirtualTable.Row, __assign({}, cellProps, { className: classes }));
    }, [expandedIds, selectedIds]);
    var SelectionCellComponent = React.useCallback(function (selectionProps) {
        var _a;
        var _b, _c, _d;
        var onToggle = selectionProps.onToggle, tableColumn = selectionProps.tableColumn, tableRow = selectionProps.tableRow, row = selectionProps.row, selected = selectionProps.selected, otherProps = __rest(selectionProps, ["onToggle", "tableColumn", "tableRow", "row", "selected"]);
        var expanded = (_c = (_b = props.rowExpansion) === null || _b === void 0 ? void 0 : _b.expandedIds.includes(props.getRowId(row))) !== null && _c !== void 0 ? _c : false;
        var cellStyles = classNames(styles.cell, styles.selectionCell, (_d = props.cellStyles) === null || _d === void 0 ? void 0 : _d.call(props, { data: row, selected: selected, expanded: expanded }));
        return (React.createElement("td", __assign({}, otherProps, { className: cellStyles, "data-test-id": 'selectionCell' }),
            React.createElement(Checkbox, { checked: selected, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggle();
                }, color: 'default', className: classNames(styles.checkboxBase, (_a = {},
                    _a[styles.selectedCheckbox] = selected,
                    _a)) })));
    }, [props.cellStyles]);
    var limitedData = !!Number(props.limit) && props.limit !== undefined
        ? props.data.filter(function (it, index) {
            return !!Number(props.limit) && props.limit !== undefined ? index < props.limit : true;
        })
        : props.data;
    var showLoadMoreFooter = !!props.limit && props.data.length > props.limit;
    var tableContainerClasses = classNames(styles.tableContainer, (_a = {},
        _a[styles.shortenContentByHeaderHeight] = props.shortenContentByHeaderHeight,
        _a));
    var TableStub = React.useCallback(function (cellProps) {
        var _a;
        var _b, _c;
        if (!props.rowExpansion)
            return React.createElement(Table.StubCell, __assign({}, cellProps));
        var expanded = cellProps.tableRow.row &&
            ((_c = (_b = props.rowExpansion) === null || _b === void 0 ? void 0 : _b.expandedIds.includes(props.getRowId(cellProps.tableRow.row))) !== null && _c !== void 0 ? _c : false);
        var classes = classNames(styles.stub, (_a = {}, _a[styles.expanded] = expanded, _a));
        return React.createElement(Table.StubCell, __assign({}, cellProps, { className: classes }));
    }, [expandedIds]);
    var selectedItemIds = (_k = (_j = props.rowChecking) === null || _j === void 0 ? void 0 : _j.selectedIds) !== null && _k !== void 0 ? _k : [];
    return (React.createElement("div", { className: tableContainerClasses, ref: containerRef },
        React.createElement(FloatingLinearProgress, { display: props.loading }),
        React.createElement(Grid, { rows: limitedData, columns: props.columns, getRowId: props.getRowId, rootComponent: RootComponent },
            !!props.rowExpansion && (React.createElement(RowDetailState, { expandedRowIds: props.rowExpansion.expandedIds, onExpandedRowIdsChange: handleRowExpansion })),
            React.createElement(SortingState, { defaultSorting: props.defaultSort, columnExtensions: props.sortingControl }),
            React.createElement(IntegratedSorting, { columnExtensions: props.customSort }),
            !!props.rowGrouping && (React.createElement(GroupingState, { grouping: props.rowGrouping.grouping, defaultExpandedGroups: props.rowGrouping.defaultExpanded })),
            !!props.rowGrouping && React.createElement(IntegratedGrouping, null),
            sanitisedScrollMode === ScrollMode.virtual ? (React.createElement(VirtualTable, { columnExtensions: props.columnExtensions, height: 'auto', cellComponent: props.cellComponent ? props.cellComponent : CellComponent, rowComponent: DefaultRowComponent, bodyComponent: TableBody, stubHeaderCellComponent: TableHeaderStub, stubCellComponent: TableStub, estimatedRowHeight: props.rowHeight ? props.rowHeight : 48, tableComponent: VirtualTableComponent, containerComponent: ContainerComponent })) : (React.createElement(Table, { columnExtensions: props.columnExtensions, cellComponent: props.cellComponent ? props.cellComponent : CellComponent, rowComponent: DefaultRowComponent, bodyComponent: TableBody, stubHeaderCellComponent: TableHeaderStub, stubCellComponent: TableStub, tableComponent: VirtualTableComponent, containerComponent: ContainerComponent })),
            !!props.rowChecking && (React.createElement(SelectionState, { selection: selectedItemIds, onSelectionChange: handleSelection })),
            !!props.rowExpansion && (React.createElement(TableRowDetail, { toggleCellComponent: props.rowExpansion.toggleCell ? CustomToggleCell : ToggleCell, toggleColumnWidth: props.rowExpansion.columnWidth, contentComponent: props.rowExpansion.content, rowComponent: DetailRowComponent, cellComponent: DetailCellComponent })),
            !!props.rowExpansion && !props.rowExpansion.expanderOnLeft && (React.createElement(Getter, { name: 'tableColumns', computed: function (_a) {
                    var tableColumns = _a.tableColumns;
                    var _b = __read(tableColumns), detailColumn = _b[0], restColumns = _b.slice(1);
                    return __spreadArray(__spreadArray([], __read(restColumns), false), [detailColumn], false);
                } })),
            React.createElement(TableHeaderRow, { cellComponent: HeaderCell, showSortingControls: false, rowComponent: function (rowProps) { var _a; return React.createElement(HeaderRow, __assign({}, rowProps, { colour: (_a = props.headerColour) !== null && _a !== void 0 ? _a : white })); } }),
            !!((_l = props.rowChecking) === null || _l === void 0 ? void 0 : _l.showSelectAll) && React.createElement(IntegratedSelection, null),
            !!props.rowChecking && (React.createElement(TableSelection, { showSelectionColumn: props.rowChecking.showSelectionColumn, showSelectAll: props.rowChecking.showSelectAll, rowComponent: props.rowChecking.rowComponent ? props.rowChecking.rowComponent : RowComponentWithSelection, headerCellComponent: function (headerProps) { return (React.createElement(HeaderSelectionCellComponent, __assign({}, headerProps, { onToggle: function () {
                        var allIds = props.data.map(props.getRowId);
                        var allSelected = selectedItemIds.length === allIds.length;
                        handleSelection(allSelected ? [] : allIds, true);
                    } }))); }, cellComponent: SelectionCellComponent, highlightRow: true })),
            !!props.rowGrouping && (React.createElement(TableGroupRow, { indentColumnWidth: 1, rowComponent: props.rowGrouping.rowComponent }))),
        showLoadMoreFooter && React.createElement(LoadMoreFooter, { showing: props.limit })));
}
